import { render, staticRenderFns } from "./EditarConvocatoriasDialogComponent.vue?vue&type=template&id=6f44eaea&scoped=true"
import script from "./EditarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarConvocatoriasDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EditarConvocatoriasDialogComponent.vue?vue&type=style&index=0&id=6f44eaea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f44eaea",
  null
  
)

export default component.exports